import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router'
import { ConnectedRouter} from 'react-router-redux';
import history from './history';
import store from './store';
import App from './pages/app';
import Sign from './pages/sign/routes';
import Home from './pages/home/routes';
import registerServiceWorker from './registerServiceWorker';
import "./static/index.css"

const rootElement = document.getElementById('root');

function render(Component) {
  ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/sign" component={Sign} />
                <App path="/" component={Home} />
            </Switch>
        </ConnectedRouter>
    </Provider>,
    rootElement
  );
}

registerServiceWorker();

render(App);



// WEBPACK FOOTER //
// ./src/index.js